import RequestPageTwo from "./RequestPageTwo";

const FiveYearMem = () => {
    return (
        <RequestPageTwo title="Five year memebership Request form"
            fetchUrl="/get-membership-requests"
            editEndpoint="update-membership-requests"
            deleteEndpoint="membership-requests"
            statusEndpoint="update-membership-requests" />
    );
}

export default FiveYearMem;
